/**
 * Helper function to reset the state in reducers
 *
 * Example usage:
 * ```
 * reducer(myAction, resetState(initialState)),
 * ```
 */
export const resetState = <State, NarrowedState extends State>(
  state: NarrowedState
) =>
  function resetStateSetter(): State {
    return state;
  };
